<div role="dialog" aria-labelledby="dialogTitle" class="api-credentials">
    <div class="modal-header">
        <h2 id="dialogTitle" class="modal-title module-title">
            {{"api-credentials-dialog.header"|translate}}
        </h2>
        <button [disabled]="false" type="button" value="Close" class="close" aria-label="Close"
            title="{{'dialog.box.close.tooltip'|translate}}" (click)="close()" >
            <span class="icon-Close" aria-hidden="true"></span>
        </button>
    </div>
    <div class="modal-body">
        <div class="col-12">
            <div class="row first-row">
                <div class='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12'>
                    <label class="text-uppercase input-label">{{"api-credentials-dialog.status"|translate}}</label>
                    <div><span class="status-text">{{(status ? "api-credentials-dialog.status." +
                            status.toLowerCase() : "api-credentials-dialog.no_credential")|translate}}</span>
                    </div>
                </div>
            </div>
            <div class="row read-only-row">
                <div class='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12'>
                    <label class="text-uppercase input-label">{{"api-credentials-dialog.created"|translate}}</label>
                    <div>
                        <span class="status-text">{{createdTime ?? ("api-credentials-dialog.no_credential"|translate)}}</span>
                        <breeze-button buttonText="{{'btn.generate'|translate}}" id="generate-btn" isSecondary="true"
                            [isDisabled]="!generateButtonEnabled" (click)="generate()">
                        </breeze-button>
                    </div>
                </div>
            </div>

            <div class='row read-only-row'>
                <div class='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12'>
                    <wfm-icontextbox #accessKeyInput inputName="accessKey" inputId="accessKey"
                        [textValue]="accessKey ?? ''"
                        iconTooltip="{{'api-credentials-dialog.copy.tooltip'|translate}}"
                        label='{{"api-credentials-dialog.access-key"|translate}}' maxLength="40" iconType="copy"
                        [showIcon]="showCopyButtons" isReadOnly=true (iconEvent)="copyAccessKey()">
                    </wfm-icontextbox>
                </div>
            </div>
            <div class='row read-only-row'>
                <div class='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12'>
                    <wfm-icontextbox #secretKeyInput inputName="secretKey" inputId="secretKey"
                        [textValue]="secretKey ?? ''"
                        iconTooltip="{{'api-credentials-dialog.copy.tooltip'|translate}}"
                        label='{{"api-credentials-dialog.secret-key"|translate}}' maxLength="40" iconType="copy"
                        [showIcon]="showCopyButtons" isReadOnly=true (iconEvent)="copySecretKey()">
                    </wfm-icontextbox>
                </div>
            </div>
            <div class="row last-row">
              <div class='col-sm-12'>
                <div class="embedded-warning" *ngIf="_showGenerateWarningMessage">
                  <i class="fa fa-warning"></i>
                  {{"api-credentials-dialog.generate.warn.msg" | translate}}
                </div>
                <div class="embedded-error" *ngIf="_showErrorMessage">
                    <i class="icon-Error_message fa"></i>
                    {{_errorMessage | translate}}
                </div>
              </div>
            </div>
        </div>
        <wfm-esp-loading-rows-overlay *ngIf="_isLoading"></wfm-esp-loading-rows-overlay>
    </div>
    <div class="modal-footer">
        <ng-template #confirmDeactivate>
          <div class="message-text">
            <p>{{'api-credentials.deactivate.confirm'|translate}}</p>
          </div>
          <div class="button-response">
            <breeze-button [isSecondary]="true" [showTooltip] = "false" buttonText="{{'popover.btn.cancel'|translate }}"></breeze-button>
            <breeze-button [isPrimary]="true" [showTooltip] = "false" buttonText="{{'btn.deactivate'|translate}}" (clicked)="deactivate()"></breeze-button>
          </div>
        </ng-template>
        <div class="modal-buttons">
            <breeze-button buttonText="{{'btn.deactivate'|translate}}" id="deactivate-btn" [isRed]="true"
                [isDisabled]="!deactivateButtonEnabled" placement="top-left auto"
                [ngbPopover]="confirmDeactivate" triggers="click" container="body" popoverClass="deactivate-popup">
            </breeze-button>

            <breeze-button buttonText="{{'btn.close'|translate}}" id="close-btn" [isPrimary]="true" [isAutoFocus]="true"
                placement="top" (clicked)="close()" [isDisabled]="!closeButtonEnabled">
            </breeze-button>
        </div>
    </div>
</div>
<p-toast position="bottom-right" class="p-toast-api-creds"></p-toast>
